import { FC } from "react";

import { Box, Modal } from "@mui/material";

import Button from "../../components/Button";
import ContentTitle from "../../components/ContentTitle";
import { CrossIcon } from "../../assets/img/icons";

import "./style.css";

interface Props {
    open: boolean;
    /** Fermeture (croix / backdrop) */
    handleClose: () => void;
    handleConfirm: () => void;
    /** Si fourni, utilisé par le bouton secondaire (sinon = handleClose) */
    handleCancel?: () => void;
    isLoading?: boolean;
    description?: string;
    title?: string;
    cancelLabel?: string;
    confirmLabel?: string;
    confirmVariant?: "primary" | "secondary" | "tertiary" | "transparent";
    cancelVariant?: "primary" | "secondary" | "tertiary" | "transparent";
}

const ConfirmModal: FC<Props> = ({
    open,
    handleClose,
    handleConfirm,
    handleCancel,
    isLoading,
    description,
    title = "Êtes-vous sûr ?",
    cancelLabel = "Annuler",
    confirmLabel = "Confirmer",
    confirmVariant = "tertiary",
    cancelVariant = "secondary",
}) => {
    const onCancel = handleCancel ?? handleClose;

    return (
        <Modal
            keepMounted
            open={open}
            onClose={handleClose}
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
        >
            <Box className="confirmModal">
                <div className="confirmModal_header">
                    <ContentTitle label={title} />
                    <CrossIcon
                        className="confirmModal_header_close"
                        onClick={handleClose}
                    />
                </div>
                {description && (
                    <p className="confirmModal_description">{description}</p>
                )}
                <div className="confirmModal_footer">
                    <Button
                        className="confirmModal_cancel_button"
                        size="medium"
                        variant={cancelVariant}
                        label={cancelLabel}
                        onClick={onCancel}
                        disabled={isLoading}
                    />
                    <Button
                        className="confirmModal_confirm_button"
                        size="medium"
                        variant={confirmVariant}
                        label={confirmLabel}
                        onClick={handleConfirm}
                        isLoading={isLoading}
                    />
                </div>
            </Box>
        </Modal>
    );
};

export default ConfirmModal;
